import { Input, Tooltip } from "antd"
import { forwardRef, useEffect, useRef, useState } from "react"
import { getTranslated, parseRefAPI, validateAttr } from "../../utils/CommonUtils"
import { applyROAccess } from "../../utils/ValidationUtils"
import { ExclamationCircleFilled } from "@ant-design/icons"
import { ERROR_RED } from "../../styles/styleUtils"
import { getRequest } from "../../utils/RequestActions"
import { useDispatch, useSelector } from "react-redux"
import { setTextFieldErr } from "../../store/reducers/CommonReducer"
import { CREATE } from "../../utils/Constants"

const TextField = forwardRef((props, ref) => {

    const [attrStatus, setAttrStatus] = useState("")
    const [value, setValue] = useState(null)
    const [readOnly, setReadOnly] = useState(false)

    const textFieldErr = useSelector(state => state.common.textFieldErr) // To set the text field status to error for a specific attribute independently
    const dict = useSelector(state => state.common.dict)

    const isDirSynchro = useSelector(state => state.uum.isDirSynchro)
    const dnNumberFromFreeRange = useSelector(state => state.uum.dnNumberFromFreeRange)

    const dispatch = useDispatch()

    const textRef = useRef()

    const isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes("firefox");


    useEffect(() => {
        if (value === null && props.value === undefined) {
            setValue(props.defaultValue)
            props.handleSchemaDataChange && props.handleSchemaDataChange(props, props.defaultValue)
        } else {
            setValue(props.value)
        }
    }, [props.value, props.defaultValue])

    useEffect(() => {
        setReadOnly(props.isReadOnly || applyROAccess(props.access, props.actionMode))
    }, [props.access, props.actionMode, props.isReadOnly])

    useEffect(() => {
        // handle ref
        if (props.actionMode === CREATE && props.refApi?.apiurl) {
            getRequest({ url: parseRefAPI(props.refApi.apiurl) }, (res, status) => {
                if (status && res?.value !== undefined) {
                    setValue(res.value)
                    props.handleSchemaDataChange && props.handleSchemaDataChange(props, res.value)
                } else {
                    // handle failure scenario
                    console.log("ref api failed")
                }
            })
        }
    }, [props.refApi?.apiurl, props.enable])

//     useEffect(() => {
//     if (props.actionMode === CREATE && props.refApi?.apiurl) {

//         const timer = setTimeout(() => {
//             console.log("Timer fired after 1s, props.refApi.apiurl:", props.refApi?.apiurl);

//             getRequest({ url: parseRefAPI(props.refApi.apiurl) }, (res, status) => {
//                 if (status && res?.value !== undefined) {
//                     setValue(res.value)
//                     props.handleSchemaDataChange && props.handleSchemaDataChange(props, res.value)
//                 } else {
//                     // handle failure scenario
//                     console.log("ref api failed")
//                 }
//             })
//         }, 5000);

//         return () => clearTimeout(timer); // cleanup
//     }
// }, [props.refApi?.apiurl, props.enable]);

    useEffect(() => {
        if (isDirSynchro && dnNumberFromFreeRange !== null && props.id === "directorynumber") {
            const timer = setTimeout(() => {
                console.log('dnValue froms tore:' + dnNumberFromFreeRange)
                setValue(dnNumberFromFreeRange)
                props.handleSchemaDataChange && props.handleSchemaDataChange(props, dnNumberFromFreeRange)
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [isDirSynchro, dnNumberFromFreeRange])

    useEffect(() => {
        if (props.validateState && value !== null) {
            setAttrStatus(validateAttr(props, value))
        }
    }, [props.validateState])

    useEffect(() => {
        if (textFieldErr?.id && textFieldErr.id === props.id) {
            setAttrStatus({ status: textFieldErr.status, errorMsg: "" })
        }
    }, [textFieldErr])

    // reset error status
    useEffect(()=>{
        if(props.resetValidateState){
            setAttrStatus({ status: textFieldErr.status, errorMsg: "" })
        }
    },[props.resetValidateState])

    //debounce logic to reduce number of schema change checking
//    const debouncedSchemaChange = useCallback(
//         debounce((val) => {
//             if (!readOnly && props.value !== val) {
//                 props.handleSchemaDataChange?.(props, val);
//             }
//         }, 300),
//         [props.value, readOnly] 
//     );

    const handleChange = (event) => {
        const newValue = event?.target?.value
        const attrStatus = validateAttr(props, newValue)
        dispatch(setTextFieldErr(""))
        setAttrStatus(attrStatus)
        setValue(newValue)
        props.handleChange && props.handleChange(newValue)
        props.handleSchemaDataChange && props.handleSchemaDataChange(props, newValue)// && debouncedSchemaChange(newValue)
    }

    const handleBlur = () => {
        if (!readOnly && props.value !== value) {
            props.handleBlur && props.handleBlur(value, props.id)
        }
    }

    return <span style={{ display: attrStatus.errorMsg ? "flex" : "" }} className={`attr-wrap ${readOnly ? "read-only" : ""}`}>
        <Input
            {...props}
            ref={textRef}
            placeholder={getTranslated(dict, props.placeholder)}
            className={`${props.className} ${props.parentClassName}`}
            value={value}
            onChange={(event) => handleChange(event)}
            {...((isFirefox && props.type === "NUMBER") ? {
                onInput: (event) => {
                    textRef?.current?.focus() //onBlur not happen in FireFox as the cursor was not pointing while updating the `number` type data via mouse arrow click
                    handleChange(event)
                },
            } : {})}
            onBlur={() => handleBlur()}
            status={attrStatus?.status}
            readOnly={readOnly}
            onPressEnter={props.onPressEnter}
            onClick={props.onClick}
            suffix={props.suffix}
            type={props.type}
            tabIndex={readOnly && -1}
        />
        {attrStatus.errorMsg ? <Tooltip title={getTranslated(dict, attrStatus.errorMsg)}>
            <ExclamationCircleFilled style={{ color: ERROR_RED, paddingLeft: "5px" }} />
        </Tooltip> :
            <></>}
    </span>
})

export default TextField